// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: プロンプトのバージョン保存（is_apply で同時に適用）
const AdminOpsPromptSaveApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_prompt_save";

    const ExecAdminOpsPromptSaveApi = async ({ groupKey, systemPrompt, userPrompt, parentV, message, isApply }) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { group_key: groupKey, system_prompt: systemPrompt, user_prompt: userPrompt, parent_v: parentV || 0, message: message || "", is_apply: isApply ? 1 : 0 } });
    };

    return ExecAdminOpsPromptSaveApi;
};

export default AdminOpsPromptSaveApi;
